import { render, staticRenderFns } from "./mail-detail.vue?vue&type=template&id=38ff8d0c"
import script from "./mail-detail.vue?vue&type=script&lang=js"
export * from "./mail-detail.vue?vue&type=script&lang=js"
import style0 from "./mail-detail.vue?vue&type=style&index=0&id=38ff8d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports